'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  align-items: center;\n  display: flex;\n  font-size: .875rem;\n  font-weight: 400;\n  justify-content: center;\n  letter-spacing: 1px;\n  line-height: 1em;\n  padding: .5rem 1.5rem;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  ', '\n\n  &:disabled {\n    background-color: ', ';\n    color: ', ';\n    cursor: initial;\n  }\n'], ['\n  ', '\n\n  align-items: center;\n  display: flex;\n  font-size: .875rem;\n  font-weight: 400;\n  justify-content: center;\n  letter-spacing: 1px;\n  line-height: 1em;\n  padding: .5rem 1.5rem;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  ', '\n\n  &:disabled {\n    background-color: ', ';\n    color: ', ';\n    cursor: initial;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: ', ';\n\n  ', '\n\n  &:not(:disabled):hover {\n    background-color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  ', '\n\n  &:not(:disabled):hover {\n    background-color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: ', ';\n'], ['\n  height: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: ', ';\n\n  ', '\n\n  &:not(:disabled):hover {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  ', '\n\n  &:not(:disabled):hover {\n    background-color: ', ';\n    color: ', ';\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  border: 1px solid ', ';\n  color: ', ';\n\n  &:disabled {\n    border: 1px solid ', ';\n\n    ', '\n  }\n\n  &:not(:disabled):hover {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n  border: 1px solid ', ';\n  color: ', ';\n\n  &:disabled {\n    border: 1px solid ', ';\n\n    ', '\n  }\n\n  &:not(:disabled):hover {\n    background-color: ', ';\n    color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _faCheck = require('@fortawesome/free-solid-svg-icons/faCheck');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _config = require('../../config.js');

var _mixins = require('../../mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonBase = _styledComponents2.default.button(_templateObject, (0, _mixins.ButtonReset)(), function (props) {
  return props.$isSuccess && '\n    svg {\n      margin-left: 12px;\n      margin-right: -8px;\n    }\n  ';
}, _config.colors.gray, _config.colors.darkGray);

ButtonBase.displayName = 'ButtonBase';

var ButtonPrimary = (0, _styledComponents2.default)(ButtonBase)(_templateObject2, _config.colors.red, _config.colors.white, function (props) {
  return props.$isSuccess && '\n    &:disabled {\n      background-color: ' + _config.colors.green + ';\n      color: ' + _config.colors.white + ';\n      font-style: italic;\n    }\n  ';
}, _config.colors.darkRed);

ButtonPrimary.displayName = 'ButtonPrimary';

var ButtonPrimaryBig = (0, _styledComponents2.default)(ButtonPrimary)(_templateObject3, (0, _rem2.default)('40px'));

ButtonPrimaryBig.displayName = 'ButtonPrimaryBig';

var ButtonSecondary = (0, _styledComponents2.default)(ButtonBase)(_templateObject4, _config.colors.white, _config.colors.red, function (props) {
  return props.$isSuccess && '\n    &:disabled {\n      background-color: ' + _config.colors.white + ';\n      color: ' + _config.colors.green + ';\n      font-style: italic;\n    }\n  ';
}, _config.colors.darkBlue, _config.colors.white);

ButtonSecondary.displayName = 'ButtonSecondary';

var ButtonGhost = (0, _styledComponents2.default)(ButtonBase)(_templateObject5, _config.colors.red, _config.colors.red, _config.colors.darkGray, function (props) {
  return props.$isSuccess && '\n      background-color: transparent;\n      border: 1px solid ' + _config.colors.green + ';\n      color: ' + _config.colors.green + ';\n      font-style: italic;\n    ';
}, _config.colors.red, _config.colors.white);

ButtonGhost.displayName = 'ButtonGhost';

/**
# Button
A basic button.
 */

var Button = function Button(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === undefined ? 'primary' : _ref$variant,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {
    return undefined;
  } : _ref$onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      children = _ref.children,
      _ref$isSuccess = _ref.isSuccess,
      isSuccess = _ref$isSuccess === undefined ? false : _ref$isSuccess,
      restProps = _objectWithoutProperties(_ref, ['variant', 'onClick', 'disabled', 'children', 'isSuccess']);

  var component = _react2.default.createElement(
    ButtonPrimary,
    _extends({
      onClick: onClick,
      disabled: isSuccess || disabled,
      $isSuccess: isSuccess
    }, restProps),
    children,
    isSuccess && _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faCheck.faCheck })
  );

  if (variant === 'primaryBig') {
    component = _react2.default.createElement(
      ButtonPrimaryBig,
      _extends({
        onClick: onClick,
        disabled: isSuccess || disabled,
        $isSuccess: isSuccess
      }, restProps),
      children,
      isSuccess && _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faCheck.faCheck })
    );
  } else if (variant === 'secondary') {
    component = _react2.default.createElement(
      ButtonSecondary,
      _extends({
        onClick: onClick,
        disabled: isSuccess || disabled,
        $isSuccess: isSuccess
      }, restProps),
      children,
      isSuccess && _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faCheck.faCheck })
    );
  } else if (variant === 'ghost') {
    component = _react2.default.createElement(
      ButtonGhost,
      _extends({
        onClick: onClick,
        disabled: isSuccess || disabled,
        $isSuccess: isSuccess
      }, restProps),
      children,
      isSuccess && _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faCheck.faCheck })
    );
  }

  return component;
};

Button.propTypes = {
  /** children to be rendered for the button */
  children: _propTypes2.default.node.isRequired,
  /** Which button variant to use. Can be `primary`, `primaryBig`, or `secondary` */
  variant: _propTypes2.default.oneOf(['primary', 'primaryBig', 'secondary', 'ghost']),
  /** A function to be called when the button is clicked */
  onClick: _propTypes2.default.func,
  /** Whether the button should be disabled */
  disabled: _propTypes2.default.bool,
  /** Whether the button is in a success state */
  isSuccess: _propTypes2.default.bool
};

Button.displayName = 'Button';

exports.default = Button;
Button.__docgenInfo = {
  'description': '# Button\r\nA basic button.',
  'methods': [],
  'displayName': 'Button',
  'props': {
    'variant': {
      'defaultValue': {
        'value': '\'primary\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'primary\'',
          'computed': false
        }, {
          'value': '\'primaryBig\'',
          'computed': false
        }, {
          'value': '\'secondary\'',
          'computed': false
        }, {
          'value': '\'ghost\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'Which button variant to use. Can be `primary`, `primaryBig`, or `secondary`'
    },
    'onClick': {
      'defaultValue': {
        'value': '() => undefined',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'A function to be called when the button is clicked'
    },
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the button should be disabled'
    },
    'isSuccess': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the button is in a success state'
    },
    'children': {
      'type': {
        'name': 'node'
      },
      'required': true,
      'description': 'children to be rendered for the button'
    }
  }
};